"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActiveStep = exports.getInitialState = exports.name = exports.reducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toolkit = require("@reduxjs/toolkit");

var _giftingFlow = require("../../giftingFlow.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  step: null
};

var _createSlice = (0, _toolkit.createSlice)({
  name: 'activeStep',
  initialState,
  reducers: {
    setStep: function setStep(state, action) {
      return _objectSpread(_objectSpread({}, state), {}, {
        step: action.payload
      });
    }
  },
  extraReducers: function extraReducers(builder) {
    return builder.addCase(_giftingFlow.resetGiftingFlowState.getType(), function () {
      return initialState;
    });
  }
}),
    reducer = _createSlice.reducer,
    name = _createSlice.name,
    setActiveStep = _createSlice.actions.setStep,
    getInitialState = _createSlice.getInitialState;

exports.getInitialState = getInitialState;
exports.setActiveStep = setActiveStep;
exports.name = name;
exports.reducer = reducer;